module.exports = ":host /deep/ ngb-pagination ul {\n  margin-bottom: 0; }\n  :host /deep/ ngb-pagination ul li {\n    font-size: 12px; }\n  :host /deep/ ngb-pagination ul li.page-item .page-link {\n      font-family: 'Open Sans', sans-serif;\n      color: #4b536b; }\n  :host /deep/ ngb-pagination ul li.page-item.active .page-link {\n      color: #ffffff;\n      background-color: #4C5369;\n      border-color: #4C5369; }\n  :host /deep/ ngb-pagination ul li.page-item.disabled .page-link {\n      opacity: .5; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/atoms/pagination/pagination.component.scss
// module id = ./src/app/shared/atoms/pagination/pagination.component.scss
// module chunks = main